module.exports = __webpack_public_path__ + "static/media/icon-asisa-blue-outline.e3155cd1.svg";